import { baseForPdf } from '../apiClients';
import { fetchAndCacheWithoutPage } from '../../components/shared/CacheStroage/CacheWithoutPage';
import { Endpoints } from '../../network';

export const getBookLandingPageData = async (slug: string) => {
  const apiUrl = `${Endpoints.getLandingPageData}/${slug}`;

  const apiCall = async () => {
    const response = await baseForPdf.get(apiUrl);
    return response?.data;
  };

  return fetchAndCacheWithoutPage(apiCall, apiUrl);
};

export const getCourseLandingPageData = async (slug: string) => {
  const apiUrl = `${Endpoints.getCourseLandingPageData}/${slug}`;

  const apiCall = async () => {
    const response = await baseForPdf.get(apiUrl);
    return response?.data;
  };

  return fetchAndCacheWithoutPage(apiCall, apiUrl);
};

export const getCourseDataSSR = async (slug: string) => {
  const urlWithQuery = `${Endpoints.getCourseLandingPageData}/${slug}`;
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_READER_URL}${urlWithQuery}`,
      { cache: 'force-cache' },
    );

    if (!response.ok) {
      throw new Error(
        `Error fetching course landing page details: ${response.statusText} `,
      );
    }

    const data = await response.json();
    return data?.data;
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};

export const getBookLandingPageDataSSR = async (slug: string) => {
  const urlWithQuery = `${Endpoints.getLandingPageData}/${slug}`;
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_READER_URL}${urlWithQuery}`,
      { cache: 'force-cache' },
    );

    if (!response.ok) {
      throw new Error(
        `Error fetching book landing page details: ${response.statusText} `,
      );
    }

    const data = await response.json();
    return data?.data;
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};

export const getLandingPageSeoSSR = async (productId: string) => {
  const urlWithQuery = `${Endpoints.getLandingPageSeoData}/${productId}`;

  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_READER_URL}${urlWithQuery}`,
      { cache: 'force-cache' },
    );

    if (!response.ok) {
      throw new Error(
        `Error fetching landing page details: ${response.statusText} `,
      );
    }

    const data = await response.json();
    return data?.data;
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};

export const getCourseLandingPageDataSSR = async (slug: string) => {
  const urlWithQuery = `${Endpoints.getCourseLandingPageData}/${slug}`;
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_READER_URL}${urlWithQuery}`,
      { cache: 'force-cache' },
    );

    if (!response.ok) {
      throw new Error(
        `Error fetching book landing page details: ${response.statusText} `,
      );
    }

    const data = await response.json();
    return data?.data;
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};

export const toggleReviewLike = async (reviewId: string) => {
  try {
    const response = await baseForPdf.post(
      `${Endpoints.getAllProductReviews}/${reviewId}/like`,
    );
    return response.data;
  } catch (error) {
    console.error('Error toggling like on review:', error);
    throw error;
  }
};

export const toggleReviewDislike = async (reviewId: string) => {
  try {
    const response = await baseForPdf.post(
      `${Endpoints.getAllProductReviews}/${reviewId}/dislike`,
    );
    return response.data;
  } catch (error) {
    console.error('Error toggling dislike on review:', error);
    throw error;
  }
};
